function shouldInitializePreview() {
  console.log("checking for preview mode");
  const urlParams = new URLSearchParams(window.location.search);
  const patrolPreview = urlParams.get("patrolPreview");

  const shouldPreview =
    patrolPreview === "true" ||
    sessionStorage.getItem("patrol_preview") === "true";

  if (shouldPreview) {
    sessionStorage.setItem("patrol_preview", "true");
  }

  return shouldPreview;
}

function showLoadingIndicator() {
  const style = document.createElement("style");
  style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
  
      .patrol-loading-indicator {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 100001;
        display: flex;
        justify-content: center;
        align-items: center;
        backdrop-filter: blur(2px);
      }
  
      .patrol-loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10001;
      }
  
      .patrol-loading-container {
        background: white;
        padding: 20px 30px;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        border: 1px solid #e5e5e5;
        color: #2c3338;
        min-width: 250px;
      }
  
      .patrol-loading-spinner {
        width: 24px;
        height: 24px;
        border: 2px solid #f3f3f3;
        border-top: 2px solid #008060;
        border-radius: 50%;
        flex-shrink: 0;
        animation: spin 1s linear infinite;
      }
  
      .patrol-loading-text {
        font-size: 14px;
        line-height: 1.4;
        color: #2c3338;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        text-align: center;
      }
    `;
  document.head.appendChild(style);
  const loadingIndicator = document.createElement("div");
  loadingIndicator.className = "patrol-loading-indicator";
  loadingIndicator.id = "patrol-loading-indicator";

  const loadingContainer = document.createElement("div");
  loadingContainer.className = "patrol-loading-container";

  const spinner = document.createElement("div");
  spinner.className = "patrol-loading-spinner";

  const text = document.createElement("div");
  text.className = "patrol-loading-text";
  text.textContent = "Loading accessibility violations...";

  loadingContainer.appendChild(spinner);
  loadingContainer.appendChild(text);
  loadingIndicator.appendChild(loadingContainer);

  document.body.appendChild(loadingIndicator);
  return loadingIndicator;
}

function hideLoadingIndicator() {
  const loadingIndicator = document.getElementById("patrol-loading-indicator");
  if (loadingIndicator) {
    loadingIndicator.remove();
  }
}

function loadPreviewScript() {
  const script = document.createElement("script");
  script.src = "/apps/patrol/servePreviewWindowScript";
  script.async = true;
  script.onerror = (error) => {
    console.error("Failed to load preview window script");
    console.log("Error details:", {
      type: error.type,
      message: error.message,
      target: error.target,
      src: script.src,
    });
    hideLoadingIndicator();
  };
  document.head.appendChild(script);
}

if (shouldInitializePreview()) {
  showLoadingIndicator();
  loadPreviewScript();
}